import {
  Box,
  IconButton,
  InputAdornment,
  CircularProgress,
  TextField,
} from "@mui/material";
import {
  VisibilityRounded,
  VisibilityOffRounded,
  SettingsSuggestRounded,
} from "@mui/icons-material";

const PasswordField = ({
  label,
  value,
  handleChange,
  show,
  handleShow,
  error,
  helperText,
  style,
  variant = "outlined",
  loading = false,
  loaderSize = 24,
  generateFunc = null,
  iconFontSize = "medium",
}) => {
  const handleMouseUpDownPassword = (event) => event.preventDefault();

  return (
    <TextField
      label={label}
      sx={{
        width: "100%",
        ...style,
      }}
      variant={variant}
      value={value}
      onChange={handleChange}
      type={show ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Box
              sx={{
                display: "flex",
                gap: 1,
                mb: generateFunc && 1,
              }}
            >
              {loading ? (
                <CircularProgress size={loaderSize} />
              ) : (
                <>
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleShow}
                    onMouseUp={handleMouseUpDownPassword}
                    onMouseDown={handleMouseUpDownPassword}
                    edge="end"
                  >
                    {show ? (
                      <VisibilityOffRounded fontSize={iconFontSize} />
                    ) : (
                      <VisibilityRounded fontSize={iconFontSize} />
                    )}
                  </IconButton>
                  {generateFunc && (
                    <IconButton
                      onClick={generateFunc}
                      edge="end"
                      sx={{ mb: 0.5 }}
                    >
                      <SettingsSuggestRounded fontSize={iconFontSize} />
                    </IconButton>
                  )}
                </>
              )}
            </Box>
          </InputAdornment>
        ),
      }}
      error={error}
      helperText={helperText}
    />
  );
};

const PasswordFieldExternalLabel = (props) => {
  const { externalLabel, ...otherProps } = props;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box>
        <span>{externalLabel}</span>
      </Box>
      <PasswordField {...otherProps} />
    </Box>
  );
};

export default PasswordField;

export { PasswordFieldExternalLabel };
